import { useEventCallback } from "usehooks-ts";
import { useEffect } from "react";
export const useCustomEventListener = (eventName, callback) => {
    const eventCallback = useEventCallback(callback);
    useEffect(() => {
        document.addEventListener(eventName, eventCallback);
        return () => {
            document.removeEventListener(eventName, eventCallback);
        };
    }, [eventName, eventCallback]);
};
//# sourceMappingURL=useCustomEventListener.js.map